import React, { useEffect, useState } from "react";
import api from "../axiosConfig";
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import "./pagination.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { deleteEntity } from "./utils/deleteEntity";

function BxcustomerList() {
  const [customers, setCustomers] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const search = searchParams.get("q") || "";
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    api
      .get("/bxcustomer")
      .then((res) => {
        setCustomers(res.data);
      })
      .catch((err) => {
        console.error("Eroare la preluare clienți:", err);
      });
  }, []);

  useEffect(() => {
    const filteredList = customers.filter(
      (c) =>
        c.bxdenumire.toLowerCase().includes(search.toLowerCase()) ||
        c.bxcodfiscal.toLowerCase().includes(search.toLowerCase()) ||
        c.bxadresa.toLowerCase().includes(search.toLowerCase()),
    );
    setFiltered(filteredList);
    setCurrentPage(0);
  }, [customers, search]);

  const handleSearchChange = (e) => {
    setSearchParams({ q: e.target.value });
  };

  const clearSearch = () => {
    setSearchParams({});
  };

  const handleDelete = async (id) => {
    if (window.confirm(`Sigur dorești să ștergi clientul cu IDx ${id}?`)) {
      try {
        await api.delete(`/bxcustomers/${id}`);
        setCustomers((prev) => prev.filter((c) => c.bxid !== id));
      } catch (error) {
        console.error("Eroare la ștergerea clientului:", error);
        alert("A apărut o eroare la ștergere.");
      }
    }
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = filtered.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filtered.length / itemsPerPage);

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col>
          <h3>Clienți</h3>
        </Col>
        <Col className="text-end">
          <Button
            variant="success"
            onClick={() => navigate("/createbxcustomer")}
          >
            Adaugare nou [+]
          </Button>

          <Button
            variant="outline-success"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="ms-2"
          >
            Back
          </Button>

          <Button
            variant="outline-success"
            href="http://localhost:8000/bxcustomer/export"
            target="_blank"
            rel="noopener noreferrer"
            className="ms-2"
          >
            Exportă CSV
          </Button>
          <Button
            variant="outline-secondary"
            href="http://localhost:8000/raport/clienți"
            target="_blank"
            rel="noopener noreferrer"
            className="ms-2"
          >
            Raport PDF
          </Button>
        </Col>
      </Row>

      <InputGroup className="mb-3">
        <FormControl
          placeholder="Cautare după denumire, cod fiscal, adresa"
          value={search}
          onChange={handleSearchChange}
        />
        {search && (
          <Button variant="outline-danger" onClick={clearSearch}>
            Clear All
          </Button>
        )}
      </InputGroup>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Denumire</th>
            <th>Cod Fiscal</th>
            <th>Adresa</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((item) => (
            <tr key={item.bxid}>
              <td>{item.bxid}</td>
              <td>{item.bxdenumire}</td>
              <td>{item.bxcodfiscal}</td>
              <td>{item.bxadresa}</td>
              <td>
                <Button
                  variant="primary"
                  size="sm"
                  className="me-2"
                  onClick={() => navigate(`/editbxcustomer/${item.bxid}`)}
                >
                  Editare
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(item.bxid)}
                >
                  Ștergere
                </Button>

                <Button
                  variant="danger"
                  size="sm"
                  onClick={() =>
                    deleteEntity({
                      endpoint: "bxcustomer",
                      id: item.bxid,
                      setState: setCustomers,
                      itemName: "bxcustomer",
                    })
                  }
                >
                  Ștergere
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <label>
        Rows per page:&nbsp;
        <select
          value={itemsPerPage}
          onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
        </select>
      </label>
      <ReactPaginate
        previousLabel={"← Înapoi"}
        nextLabel={"Înainte →"}
        pageCount={pageCount}
        onPageChange={handlePageClick}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </Container>
  );
}

export default BxcustomerList;
